<div class="layout">
  @if (isAuthenticated) {
    <app-sidebar></app-sidebar>
  }
  <div class="content">
    <router-outlet></router-outlet>
  </div>
</div>
